export default "__VITE_ASSET__DhqhPV2V__"